import React from "react";
import "./MobileMenu.scss";
import ButtonRed from "../ButtonRed";
import { useNavigate } from "react-router-dom";
import MobileMenuItem from "./MobileMenuItem";

function MobileMenu() {
  const navigate = useNavigate();
  return (
    <div className={`mobile-menu opened`}>
      <div className='logo'>
        <div className='button-position'>
          <ButtonRed
            labelText='Play'
            onClick={() => {
              navigate("/game");
            }}
          />
        </div>
      </div>

      <div className='mobilemobilemenu-items'>
        <div className='mobilemenu-group'>
          <MobileMenuItem
            textLabel='Guide'
            iconUrl='/icon/guide_icon.png'
          />
        </div>
        <div className='mobilemenu-group'>
          <MobileMenuItem
            textLabel='Leaderboards'
            iconUrl='/icon/leaderboard_icon.png'
          />
          <div className='mobilemenu-item-separator'/>
          <MobileMenuItem
            textLabel='Welcome bonus'
            iconUrl='/icon/bonus_icon.png'
          />
        </div>
        <div className='mobilemenu-group'>
          <MobileMenuItem textLabel='Slots' iconUrl='/icon/slots_icon.png' />
          <div className='mobilemenu-item-separator'/>
          <MobileMenuItem
            textLabel='My Bonuses'
            iconUrl='/icon/my_bonus_icon.png'
          />
          <div className='mobilemenu-item-separator'/>
          <MobileMenuItem
            textLabel='Support chat'
            iconUrl='/icon/support_icon.png'
          />
        </div>
      </div>
    </div>
  );
}
export default MobileMenu;
